import React from "react";
import { formatPrice } from "../utils/formatPrice";

const SplitBillBar = ({
  selectedCount,
  selectedUnitCount,
  selectedTotal,
  remainingTotal,
  hasLockedGroups,
  onLock,
  onClear,
  onClose,
}) => (
  <div className="guest-split-bar">
    <div className="guest-split-bar-inner">
      <div className="guest-split-bar-summary">
        {selectedCount > 0 ? (
          <>
            <span className="guest-split-bar-count">{selectedUnitCount} ürün seçildi</span>
            <span className="guest-split-bar-total">{formatPrice(selectedTotal)}</span>
          </>
        ) : hasLockedGroups ? (
          <>
            <span className="guest-split-bar-hint">Kalan tutar</span>
            <span className="guest-split-bar-total">{formatPrice(remainingTotal)}</span>
          </>
        ) : (
          <span className="guest-split-bar-hint">Ödeyeceğiniz ürünlere dokunun</span>
        )}
      </div>
      <div className="guest-split-bar-actions">
        {selectedCount > 0 && (
          <>
            <button className="guest-split-bar-lock" onClick={onLock}>
              Kilitle ✓
            </button>
            <button className="guest-split-bar-clear" onClick={onClear}>
              Temizle
            </button>
          </>
        )}
        <button className="guest-split-bar-close" onClick={onClose}>
          Kapat
        </button>
      </div>
    </div>
  </div>
);

export default SplitBillBar;
